export const INPUTS = {
    inputs: 'inputs'
}